import Dashboard from "layouts/dashboard";
import AdminPage from "pages/LayoutContainers/Admin/index";
import UserManager from "pages/LayoutContainers/AccountAdmin";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";


// @mui icons
import Icon from "@mui/material/Icon";

const routes = [
  {
    type: "collapse",
    name: "提现审核",
    key: "tables",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/tables",
    component: <Dashboard />,
  },
  
  {
    type: "collapse",
    name: "房东审核",
    key: "adminPage",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/adminPage",
    component: <AdminPage />,
  },
  
  {
    type: "collapse",
    name: "账号管理",
    key: "account",
    route: "/account",
    icon: <Icon fontSize="small">table_view</Icon>,
    component: <UserManager />,
  },
  // {
  //   type: "collapse",
  //   name: "活动管理",
  //   key: "activity",
  //   route: "/tables/activity/:id",
  //   component: <ActivityForm />,
  //   hidden: true
  // },
  // {
  //   type: "collapse",
  //   name: "Billing",
  //   key: "billing",
  //   icon: <Icon fontSize="small">receipt_long</Icon>,
  //   route: "/billing",
  //   component: <Billing />,
  // },
  // {
  //   type: "collapse",
  //   name: "RTL",
  //   key: "rtl",
  //   icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
  //   route: "/rtl",
  //   component: <RTL />,
  // },
  // {
  //   type: "collapse",
  //   name: "Notifications",
  //   key: "notifications",
  //   icon: <Icon fontSize="small">notifications</Icon>,
  //   route: "/notifications",
  //   component: <Notifications />,
  // },
  // {
  //   type: "collapse",
  //   name: "Profile",
  //   key: "profile",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: "/profile",
  //   component: <Profile />,
  // },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
    hidden: true
  },
  {
    type: "collapse",
    name: "Sign Up",
    key: "sign-up",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/sign-up",
    component: <SignUp />,
    hidden: true
  },
];

export default routes;
